'use client';

import {
  BottomSheetHandleArea,
  BottomSheetTitle,
  BottomSheetTitleBox,
  BottomSheetTitleContainer,
  Dim,
  IcDelete,
  IcInfo,
  IconButton,
  Sheet,
  SheetContent,
  SheetDimMotion,
  SheetMotion,
  SheetPortal,
  SheetTrigger,
  Typography,
} from '@musinsa/mds';
import { useState } from 'react';
import { twMerge } from 'tailwind-merge';

const COUPON_GUIDE_ITEMS = [
  '큐레이터가 제공하는 쿠폰은 지정된 상품에 한해, 유효 기간 내 구매 시 적용할 수 있습니다.',
  '동일 쿠폰은 계정당 1회만 발급되며, 중복 사용은 제한됩니다.',
  '큐레이터 쿠폰은 최소 1만 원 이상 구매 시 사용 가능하며, 최대 10만 원까지 할인됩니다.',
];

interface CouponTitleSectionProps {
  title: string;
  className?: string;
}

export const CouponTitleSection = ({ title, className }: CouponTitleSectionProps) => {
  const [open, setOpen] = useState(false);

  return (
    <div className={twMerge('flex items-center gap-1 bg-gray-100 px-4 py-3', className)}>
      <Typography variant="title18pxMed">{title}</Typography>

      <Sheet direction="bottom" open={open}>
        <SheetTrigger asChild onClick={() => setOpen(true)}>
          <IconButton size="size20x20">
            <IcInfo />
          </IconButton>
        </SheetTrigger>
        <SheetPortal>
          <SheetContent onPointerDownOutside={() => setOpen(false)}>
            <SheetMotion direction="bottom">
              <BottomSheetTitle>
                <BottomSheetHandleArea />
                <BottomSheetTitleContainer>
                  <BottomSheetTitleBox>큐레이터 쿠폰 사용 가이드</BottomSheetTitleBox>
                  <IconButton size="size28x28" onClick={() => setOpen(false)}>
                    <IcDelete />
                  </IconButton>
                </BottomSheetTitleContainer>
              </BottomSheetTitle>
              <div className="flex flex-col gap-12 px-[16px]! pb-[32px]! safe-area-bottom">
                {COUPON_GUIDE_ITEMS.map((item) => (
                  <div key={item} className="flex gap-[4px]">
                    <Typography variant="body13pxReg" colorScheme="gray-600" className="shrink-0">
                      •
                    </Typography>
                    <Typography variant="body13pxReg" colorScheme="gray-600">
                      {item}
                    </Typography>
                  </div>
                ))}
              </div>
            </SheetMotion>
          </SheetContent>
          <SheetDimMotion>
            <Dim />
          </SheetDimMotion>
        </SheetPortal>
      </Sheet>
    </div>
  );
};
